import $ from 'jquery';
import 'bootstrap/js/collapse';

export default () => {
  $('.js-accordion-collapse').on('show.bs.collapse', (evt) => {
    $(evt.target).prev().addClass('active');
  });

  $('.js-accordion-collapse').on('hide.bs.collapse', (evt) => {
    $(evt.target).prev().removeClass('active');
  });

  $(() => {
    // Init accordion
    const $collapses = $('.js-accordion-collapse', '.js-accordion');
    const $collapsers = $('.js-accordion-collapser', '.js-accordion');

    $collapses.each((_, collapse) => {
      $(collapse).collapse({ parent: $(collapse).closest('.js-accordion'), toggle: false });
    });

    // Toggle accordion categories
    $collapsers.on('click', function onCollapseClick() {
      const $collapsible = $(this).next();
      const $accordion = $(this).closest('.js-accordion');

      $accordion.find('.js-accordion-collapse').not($collapsible).collapse('hide');
      $collapsible.collapse('toggle');
    });
  });
};
